"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSessionToken = exports.respond = exports.request = exports.Action = void 0;
var types_1 = require("../types");
var helper_1 = require("../helper");
var Error_1 = __importStar(require("../Error"));
var validator_1 = require("../validator");
var Action;
(function (Action) {
    Action["REQUEST"] = "APP::SESSION_TOKEN::REQUEST";
    Action["RESPOND"] = "APP::SESSION_TOKEN::RESPOND";
})(Action = exports.Action || (exports.Action = {}));
function request() {
    return helper_1.actionWrapper({
        group: types_1.Group.SessionToken,
        type: Action.REQUEST,
    });
}
exports.request = request;
function respond(sessionToken) {
    return helper_1.actionWrapper({
        payload: sessionToken,
        group: types_1.Group.SessionToken,
        type: Action.RESPOND,
    });
}
exports.respond = respond;
function getSessionToken(app) {
    return new Promise(function (resolve, reject) {
        if (validator_1.isAppNotInIframe()) {
            reject(Error_1.fromAction('Failed to retrieve a session token', Error_1.Action.FAILED_AUTHENTICATION));
        }
        else {
            var unsubscribe = app.subscribe(Action.RESPOND, function (_a) {
                var sessionToken = _a.sessionToken;
                var errorCode = _a.errorCode;
                if (sessionToken) {
                    resolve(sessionToken);
                }
                else if (errorCode) {
                    reject(Error_1.fromAction('Failed to retrieve a session token', errorCode));
                }
                else {
                    reject(Error_1.fromAction('Failed to retrieve a session token', Error_1.Action.FAILED_AUTHENTICATION));
                }
                unsubscribe();
            });
            app.dispatch(request());
        }
    });
}
exports.getSessionToken = getSessionToken;
